import { Col, Container, Row } from 'react-bootstrap';
import { SalvLogo } from './SalvLogo';
import React, { ReactNode } from 'react';

type ExternalContainerProps = {
  children?: ReactNode;
  size?: number;
};

export const ExternalContainer = ({ children, size = 75 }: ExternalContainerProps) => {
  return (
    <Container fluid={true} className='vh-100 vw-100'>
      <Container className={`w-${size}`}>
        <Row>
          <Col className='text-center p-6'>
            <SalvLogo dark width={200} />
          </Col>
        </Row>
        {children}
      </Container>
    </Container>
  );
};
